import 'choerodon-ui/lib/style/index.less';
import 'choerodon-ui/lib/collapse/style';
import 'choerodon-ui/lib/grid/style';
import 'choerodon-ui/lib/tag/style';
import 'choerodon-ui/lib/popover/style';
import './index.less';
// style dependencies
import '../../form/style';
import '../../output/style';
import '../../button/style';
import '../../radio/style';
import '../../check-box/style';
import '../../text-field/style';
import '../../secret-field/style';
import '../../color-picker/style';
import '../../currency/style';
import '../../number-field/style';
import '../../intl-field/style';
import '../../url-field/style';
import '../../email-field/style';
import '../../lov/style';
import '../../select/style';
import '../../select-box/style';
import '../../tree-select/style';
import '../../date-picker/style';
import '../../spin/style';
import '../../pagination/style';
import '../../modal-container/style';
import '../../tooltip/style';
import '../../validator/style';
import '../../switch/style';
import '../../menu/style';
import '../../dropdown/style';
import '../../attachment/style';
import '../customization-settings/style';
import '../combo-customization-settings/style';
import '../query-bar/style';
